import React from 'react'

import { IconTitleDescriptionImageItem } from '@application/Interfaces/Features/IconTitleDescriptionImage/IconTitleDescriptionImageItem/IconTitleDescriptionImageItem'
import { ImageGrid } from '@application/Interfaces/Features/IconTitleDescriptionImage/ImageGrid/ImageGrid'
import { IconTitleDescriptionImageType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { TitleSection } from '@organisms/TitleSection'

export const IconTitleDescriptionImage = ({
    iconTitleDescriptionImageTitle,
    subtitle,
    images,
    items,
    imageAnimation,
}: IconTitleDescriptionImageType): JSX.Element => (
    <TitleSection title={iconTitleDescriptionImageTitle} subtitle={subtitle}>
        <Grid container>
            {items && (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    spacingTop={3}
                    mdUpSpacingRight={5}
                    lgSpacingRight={15}
                    xsSpacingBottom={3}
                    container
                    justifyContent="space-between"
                    direction="column"
                >
                    {items.map((item, i) => (
                        <Grid item key={`${item.title}-${i}`} spacingBottom={3}>
                            <IconTitleDescriptionImageItem {...item} />
                        </Grid>
                    ))}
                </Grid>
            )}
            {images && (
                <Grid item xs={12} sm={6}>
                    <ImageGrid images={images} imageAnimation={imageAnimation} />
                </Grid>
            )}
        </Grid>
    </TitleSection>
)
